module.exports = __webpack_public_path__ + "assets/images/project/united-kingdom-desktop.jpg?v=96913b99";